import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'

i18next.use(LanguageDetector).init({
  fallbackLng: 'en',
  debug: true,
  resources: {
    en: {
      translation: {
        Add: 'Add',
        Add_Additional_Button_Text: 'Add Additional',
        Add_Bulk_Users: 'Bulk Add People',
        Add_Bulk_Users_Help:
          'Add users by their Air Products email address from the Outlook address book. Add one user per line. Existing users will be pulled in from the form and if they are removed from the bulk input, they will be removed from the form. ',
        Add_Fyis: 'Add Fyis',
        Add_Item_Status: 'Add Item Status',
        Add_Manual_Task: 'Add Manual Task',
        Add_Possible_Responses: 'Add Possible Responses',
        Add_Standard: 'Add Standard',
        Add_Supporting_Link: 'Add Supporting Link',
        Add_Third_Party_User: 'Add Third Party User in accordance with Air Products Information Classification',
        Additional_Approvers: 'Additional Approvers',
        Additional_FYI: 'Additional FYI',
        Additional_Fyis: 'Additional Fyis',
        Approval_Process_Type: 'Approval Process Type',
        Approval_Confirmation: 'Approval Confirmation',
        Approvals: 'Approvals',
        Approve: 'Approve',
        Approved: 'Approved',
        Approver: 'Approver',
        Approvers: 'Approvers',
        Archive: 'Archive',
        Archives: 'Archives',
        Assigned: 'Assigned',
        Assigned_To: 'Assigned To',
        At_Least_One_Item_Status_Is_Required: 'At least one item status is required',
        Attach_Link: 'Attach a Link',
        Being_Viewed_By: 'Being viewed by',
        Cancel: 'Cancel',
        Cancel_Reply: 'Cancel Reply',
        Category_Accountable: 'Where I am accountable for the process or system that is being changed',
        Category_CoInit: 'Where I am Co-Initiator',
        Category_ConfirmChange: 'That I have to confirm change has been implemented and has been completed to my satisfaction',
        Category_Facilitator: 'Where I facilitate implementation',
        Category_FYI: 'With information I may need to know about',
        Category_Init: 'Where I am Initiator',
        Category_InProcess: 'All in Process',
        Category_InProcessClosed: 'All in Process + Closed',
        Category_InProcessFacilitatorSentBack: 'All Sent Back where I am Facilitator/Backup',
        Category_InProcessFacilitatorSubmitted: 'All Submitted where I am Facilitator/Backup',
        Category_PendingApproval: 'Pending my approval as Owner',
        Category_PendingTasks: 'With tasks that I am assigned',
        Category_Stop: 'I may want to stop',
        Category_WaitingForApproval: 'Waiting for my approval now',
        Change: 'Change',
        Change_Category: 'Change Category',
        Change_Start_Date_Coordinator: 'Change Start Date and/or Coordinator',
        Change_Start_Date_Coordinator_Valid_Until_Temp: 'Change Start Date, Valid Until Date and/or Coordinator',
        Change_Type: 'Change Type',
        Browse_Files: 'Click here to browse files',
        Download_This_Version: 'Click to download this version',
        Close: 'Close',
        Closed_Voided_By: 'Closed Voided By',
        Closed_Voided_Reason: 'Closed Voided Reason',
        Closer_Denied_By: 'Closer Denied By',
        Closer_Denied_Date: 'Closer Denied Date',
        Closer_Denied_Reason: 'Closer Denied Reason',
        Coordinator_Actions: 'Coordinator Actions',
        'Co-Initiator': 'Co-Initiator',
        'Co-Initiator_Readonly': 'Co-Initiator (if any)',
        Closed_Stranded_Justification: 'Closed Stranded Justification',
        Closed_Stranded_By: 'Closed Stranded By',
        Comment: 'Comment',
        Comments: 'Comments',
        Community: 'Community',
        Complete_Return_To_Original: 'Complete Return To Original',
        Completed: 'Completed',
        Completed_By: 'Completed By',
        Completed_Date: 'Completed Date',
        Confirm_AreYouSure: 'Are you sure?',
        Confirm_Change_Is_Fully_Implemented: 'Confirm change is fully implemented',
        Confirm_Change_Is_Fully_Implemented_Return_To_Original: 'Confirm Change has been fully returned to original condition',
        Confirm_DeleteAttachment: 'Are you sure you want to delete this attachment?',
        Confirm_DeleteLink: 'Are you sure you want to delete this link?',
        Confirm_ExitWithoutSaving: "Are you sure you want to 'Exit without Saving'?",
        Confirm_OwnerIsApproverSaving:
          '{{person}} is listed as an owner and approver. Are you sure you want to continue saving the form?',
        Coordinator: 'Coordinator',
        Create_Link: 'Create New Link',
        Created_By: 'Created by',
        Created_On: 'Created on',
        Date: 'Date',
        Date_Initiated: 'Date Initiated',
        Date_Submitted: 'Date Submitted',
        Date_Not_In_Past: 'This date cannot be in the past',
        Decision: 'Decision',
        Delete: 'Delete',
        Discussion: 'Discussion',
        Display_Order: 'Display Order',
        Drop_Files: 'Drop Files Here',
        Download_Tasks: 'Download Tasks',
        Download: 'Download',
        Download_Selected: 'Download Selected Files',
        Downloading_Files: 'Downloading {{completed}} of {{total}} file(s)...',
        Edit: 'Edit',
        Edit_Link: 'Edit Link',
        Error_ApprovalCount: 'Could not receive Approval Count for {{mocId}}',
        Error_CommunityData: 'Could not receive community data for {{mocId}}',
        Error_DeleteDocument: 'Could not delete document',
        Error_DeleteLink: 'Could not delete link',
        Error_DownloadDocument: 'Could not download document',
        Error_DownloadEmoc1ArchiveFailed: 'Could not download archive.',
        Error_DownloadTooLarge: 'The selected files are too large to download together. Please select fewer files and try again.',
        Error_DuplicateName: 'This is a duplicate file name.',
        Error_GetComments: 'Could not obtain comments for {{mocId}}',
        Error_GetDocuments: 'Could not retrieve documents',
        Error_GetLinks: 'Could not retrieve links',
        Error_GetMOCApprovals: 'Could not receive Approvals for MOC {{mocId}}',
        Error_InitiatorRequired: 'Initiator is required',
        Error_MOCForm: 'Could not receive MOC Form {{mocId}}',
        Error_NoMOCApprovals: 'There are no Approvals for MOC {{mocId}}',
        Error_SaveLink: 'Could not save link',
        Error_Search: 'An error has ocurred',
        Error_SendNotification: 'Could not send notification',
        Error_TitleRequired: 'Title is required to save.',
        Error_TitleRequiredDraft: 'Title is required to save as draft.',
        Error_Unauthorized: 'Unauthorized',
        Error_UploadDocument: 'Could not upload document',
        Error_UpdateLink: 'Could not update link',
        Error_updateComment: 'Could not update document',
        Error_VoidReasonRequired: 'Void Reason is required',
        Exit: 'Exit',
        Exit_Without_Saving: 'Exit without Saving',
        Extend: 'Extend',
        Extend_All_Approvers: 'All Approvers',
        Extend_Select_Date: 'You have selected to extend the duration of the temporary change; select date',
        Extended_Owner_Approval_Date: 'Extended Owner Approval Date',
        Extended_Over_180_Message:
          'To extend the duration of the temporary change to {{newValidUntilDate}} you are required to have additional approval per',
        Extended_Over_180_Link: 'https://www.google.com',
        Extended_Over_180_Link_Label: '25-010905',
        Extended_Under_180_Message:
          'To extend the duration of the temporary change to {{newValidUntilDate}} do you need to have any additional input from anyone?',
        Facilitator_Actions: 'Facilitator Actions',
        Facilitator_Backup: 'Facilitator Backup',
        Facilitator: 'Facilitator',
        File_Name: 'File Name',
        FYIs: 'FYIs',
        Help: 'Help',
        Helpful_Links: 'Helpful Links',
        Hide: 'Hide',
        History: 'History',
        Immediately_On_Owner_Decision: 'Immediately on Owner Decision',
        Insert_Users: 'Insert Users',
        Confirm_Change_Is_In_Place: 'Confirm change is in place',
        // Info_AddBothExtendFYIAndApprover: 'You are attempting to add {{person}} as both an approver and FYI.',
        // Info_AddBothFYIAndApprover: 'You are attempting to add {{person}} as both an approver and FYI.',
        // Info_AlreadyApprover: 'Individual is already listed as an approver',
        Info_AlreadyInitiator: 'Individual is already listed as the Initiator',
        // Info_AlreadyFYI: '{{person}} is already listed as an FYI.',
        Info_AlreadyHasRole: '{{person}} is already listed as an Approver and/or an FYI.',
        Info_AlreadyOwner: '{{person}} is already an owner.',
        Info_FYIAlreadyApprover:
          'You are attempting to add {{person}} as an FYI, but they are already required to be an approver based on the responses.',
        Initiator: 'Initiator',
        Initiator_Actions: 'Initiator Actions',
        Input_Required_From_Additional_Approvers: 'Input Required From Additional Approvers',
        Is_Required: 'is required',
        Item_Status: 'Item Status',
        Last_Modified_By: 'Last Modified By',
        Loading: 'Loading..',
        Make_Permanent: 'Make Permanent',
        Make_Permanent_Editable_Text:
          'Update the MOC Title, Description, Justification, Approvers and tasks as required to describe the work involved in making the change permanent.',
        Make_Permanent_Owner_Editable: 'Make Permanent Owner Editable',
        Make_Permanent_Text: 'You have selected leave the temporary change in place permanently.',
        Make_Revisions: 'Make Revisions',
        Mandatory: 'Mandatory',
        Manual_Task_Added_By: 'Manual Task Added By',
        MOC_Description: 'MOC Description',
        MOC_Does_Not_Exist: 'MOC does not exist.',
        MOC_ID: 'MOC ID',
        MOC_Justification: 'MOC Justification',
        MOC_Not_Found_Bad_Url: 'MOC not found',
        MOC_Type: 'MOC Type',
        Modified_By: 'Modified by',
        Modified_On: 'Modified on',
        Multipass: 'Multipass',
        My_Approval: 'My Approval',
        Name: 'Name',
        New_Comment: 'New Comment',
        No_Comment: 'No Comment',
        No_Comment_Provided: 'No Comment Provided',
        No_Comments: 'No Comments',
        No_Reason: 'No Reason',
        No_Response: 'No Response',
        No_Results: 'No Results',
        No: 'No',
        Not_OK: 'Not OK',
        Not_Ready_To_Close: 'Not Ready To Close',
        Notification_ApproveChange: 'You have decided to APPROVE this proposed change',
        Notification_ChangeConfirmedSatisfactorily:
          'It has been confirmed the change has been implemented and all actions have been completed satisfactorily.',
        Notification_ChangeNotSatisfactorily: 'All actions were not completed satisfactorily.',
        Notification_DeletingAttachment: 'Deleting an attachment will delete all history and can not be undone.',
        Notification_DeletingLink: 'Deleting a link will delete all history and can not be undone.',
        Notification_Owner_Approved_Multipass_Message: 'You are approving this decision to proceed to the next pass.',
        Notification_ReduceApproverTime:
          'You have decided to reduce the time that this change will be available for approvers to make their decision. You must have provided evidence in Supporting Documents that the Owner concurs.',
        Notification_RejectChange: 'You have decided to REJECT this proposed change',
        Notification_RejectedChange:
          'You have Rejected this change proposal; no further action can be taken. A record of your decision and supporting information will be retained.',
        Now_You_May_Select: 'Now you may select',
        OK: 'OK',
        Ok_Upload: 'Ok, Upload',
        Ok_Attach: 'Ok, Attach',
        One_Item_Must_Complete_The_Task: 'One item must complete the task',
        Owner: 'Owner',
        Owner_Actions: 'Owner Actions',
        Owner_Approval_Confirmation_Permanent:
          'You have approved implementation of this change; it will be managed by <b>{{coordinator}}</b>. Work on implementing the change may begin on <b>{{startDate}}</b> and should be completed by <b>{{startDatePlus365}}</b>',
        Owner_Approval_Confirmation_Temporary:
          'You have approved implementation of this change; it will be managed by <b>{{coordinator}}</b>. Work on implementing the change may begin on <b>{{startDate}}</b> and temporary change authorization will expire on <b>{{validUntilDate}}</b>',
        Owner_Approval_Confirmation_Temporary_Make_Permanent:
          'You have elected to make this change permanent; any work required to do that will be managed and confirmed completed by {{coordinator}}.',
        Owner_Approval_Confirmation_Temporary_Extend:
          'You have now authorized this temporary change to be in place until {{validUntilDate}}.',
        Owner_Agreed: 'Owner Agreed',
        Owner_Decision: 'Owner Decision',
        Owner_Did_Not_Agree: 'Owner did not agree',
        Owner_Temporary_Actions: 'Owner Temporary Actions',
        Owner_Revisions_Needed: 'Owner Revisions Needed',
        Permanent: 'Permanent',
        Please_Check_Url: 'Please check the URL',
        Possible_Responses: 'Possible Responses',
        Preparing_Download: 'Preparing download...',
        Preset_Approvers: 'Preset Approvers',
        Preset_FYIs: 'Preset FYIs',
        Prompt_ActionsNotCompletedSatisfactorily: 'Explain why the actions were not completed satisfactorily.',
        Prompt_ApproveComments: 'Comments in support of your approve decision',
        Prompt_AssistFacilitatorComments: 'Comments to assist facilitator with processing this MOC',
        Prompt_CommentsToSupportDecision: 'Comments in support of your decision',
        Prompt_FileComments: 'Type file comments here',
        Prompt_LinkComments: 'Type link comments here',
        Prompt_LinkName: 'Name of Link',
        Prompt_PasteLink: 'PASTE URL HERE',
        Prompt_RejectComments: 'Comments in support of your reject decision',
        Prompt_TypeToSearch: 'Start typing to Search',
        Prompt_VoidProcess: 'For any activity implementing this change, document how it will be removed or undone.',
        Prompt_VoidUndoneWork: 'Description of what work was undone as a result of void.',
        Ready_To_Close: 'Ready to Close',
        Reason: 'Reason',
        Reason_For_Send_Back: 'Reason for Send Back',
        Reason_For_Void: 'Reason for Void',
        Reject: 'Reject',
        Reject_Confirmation: 'Reject Confirmation',
        Rejected: 'Rejected',
        Related_Change_Type: 'Related Change Type',
        Remind_Non_Responders: 'Remind non responders',
        Reply: 'Reply',
        Replying_To: 'Replying to',
        Required_In_Order_To: 'Required in order to',
        Required_In_Order_To_Is_Required: 'Required in order to is required',
        Response: 'Response',
        Return_MOC_To_Coordinator: 'Return MOC to coordinator',
        Return_To_Original_Condition: 'Return to original condition',
        Return_To_Original_Condition_Text:
          'You have selected return the system to its original condition and remove the temporary change.',
        Return_To_Original_Confirmation:
          'Are there risks, system updates or actions that require prompting involved in the returning the system to its original condition?',
        Return_To_Original_Confirmation_False_Task_Name:
          'Confirm that actions have been completed to return the system to its original condition',
        Return_To_Original_Confirmation_True_Task_Name:
          'Confirm that actions have been completed addressing risks and system changes in returning the system to its original condition',
        Retrieving_Documents: 'Retrieving Documents',
        Retrieving_Links: 'Retrieving Links',
        Revision_Confirmation: 'Revision Confirmation',
        Revision_By: 'Requested By',
        Revision_Date: 'Date',
        Revision_Reason: 'Revision Reason',
        Revisions_Needed: 'Revisions needed before approval can be given',
        Rule_BackupFacilitatorNotFacilitator: 'Backup Facilitator cannot be the same as facilitator',
        Rule_FacilitatorNotBackup: 'Facilitator cannot be the same as backup facilitator',
        Rule_Required: 'Required',
        Rule_Required_ApprovalProcessType: 'Approval Process Type is required',
        Rule_Required_ChangeCategory: 'Change category is required',
        Rule_Required_Comment: 'Comment is required',
        Rule_Required_Coordinator: 'Coordinator is required',
        Rule_Required_Owner: 'Owner is required',
        Rule_Required_Facilitator: 'Facilitator is required',
        Rule_Required_Initiator: 'Initiator is required',
        Rule_Required_MOCDescription: 'MOC Description is required',
        Rule_Required_MOCJustification: 'MOC Justification is required',
        Rule_Required_MOCType: 'MOC Type is required',
        Rule_Required_Revision: 'Revision is required',
        Rule_Required_SendBackReason: 'Send Back Reason is required',
        Rule_Required_Title: 'Title is required',
        Rule_Required_ValidUntilDate: 'Valid Until Date is required',
        Rule_Required_VoidReason: 'Void Reason is required',
        Rule_Task_Must_Be_Satisfied: 'Task must be satisfied',
        Rule_MaximumLength: 'Maximum length is {{length}}',
        Rule_MinimumLength: 'Minimum length is {{length}}',
        Rule_ExactLength: 'Invalid character length, required {{length}}',
        Save: 'Save',
        Save_Continue: 'Save and Continue',
        Save_Revise: 'Save and Revise',
        Save_Send_Back: 'Save and Send Back',
        Save_Void: 'Save and Void',
        Save_Comment: 'Save Comment',
        Save_Draft: 'Save Draft',
        Select_Additional_Approvers: 'Select additional approvers',
        Select_Additional_Fyis: 'Select additional fyis',
        Select_Approved_To_Start_Date: 'Select approved to start date',
        Select_Approval_Process_Type: 'Select Approval Process Type',
        Select_Coordinator: 'Select Coordinator',
        Send_Back: 'Send Back',
        Send_Decision: 'Send for Decision',
        Send_Owner_Decision: 'Send for Owner Decision',
        Sent_Back_By: 'Sent Back By',
        Sent_Back_Date: 'Sent Back Date',
        Sent_Back_Reason: 'Sent Back Reason',
        Set_Make_Permanent: 'Set Make Permanent',
        Show: 'Show',
        Show_All_Tasks: 'Show All Tasks',
        Standards: 'Standards',
        Start_Date_Proposed: 'Start Date Proposed',
        Status: 'Status',
        Step: 'Step',
        Step_Is_Required: 'Step is required',
        Submit: 'Submit',
        Submitted_Successfully: 'Submitted Successfully',
        Success_AdditionalApproverAdded: 'Additional approver added successfully',
        Success_AdditionalFyiAdded: 'Additional fyi added successfully',
        Success_CloserDeniedSaved: 'Return to coordinator saved successfully',
        Success_ClosedVoidSaved: 'Closed Void saved successfully.',
        Success_ClosedVoidedSaved: 'Closed Voided saved successfully.',
        Success_CommentSaved: 'Comment saved Successfully',
        Success_MakeRevisionsSaved: 'Make Revisions saved Successfully',
        Success_OwnerApprovalSaved: 'Owner Approval saved Successfully',
        Success_OwnerClosed: 'Owner closed successfully',
        Success_OwnerFormChanges: 'Owner Form Changes Saved Successfully',
        Success_OwnerRejectSaved: 'Owner Reject saved Successfully',
        Success_ReminderSent: 'Reminder Sent',
        Success_Saved: 'Saved Successfully.',
        Success_SendBackSaved: 'Send Back saved Successfully',
        Success_SentForDecision: 'Sent for Decision successfully',
        Success_SentToPendingOwnerDecision: 'Sent to Pending Owner Decision successfully',
        StartDate_Before_ValidUnitDate: 'Start date must be before valid until date',
        Supporting_Documents: 'Supporting Documents',
        Supporting_Links: 'Supporting Links',
        Success_SubmitStrandedSaved: 'Closed Stranded saved successfully.',
        Task: 'Task',
        Task_Comment: 'Task Comment',
        Task_Issue_Message:
          'An unexpected error has occurred related to required tasks presented on the form.  Please click Save and Continue again to resolve this issue and click submit again.  If you continue to see this error message, please contact support',
        Task_Issue_Not_All_Complete_Message:
          'All Tasks for this status are not complete, Please refresh the MOC and complete all necessary tasks before trying to move forward.',
        Task_Satisfied: 'Task Satisfied',
        Task_Type: 'Task Type',
        Tasks: 'Tasks',
        Task_Is_Required: 'Task is required',
        Tasks_To_Do_Now: 'Tasks to do now',
        Temporary: 'Temporary',
        This_Field_Cannot_be_Less_Than_Zero: 'This field cannot be less than zero',
        This_Moc_Is_Unauthorized_Expired: 'THIS MOC IS UNAUTHORIZED EXPIRED',
        Title: 'Title',
        Unauthorized_Expired: 'Unauthorized Expired',
        Unauthorized_Expired_Message_General:
          'You are past the point where there is approval to continue to work under this temporary MOC.  Contact the owner now.',
        Unauthorized_Expired_Message_Owner:
          'You are past the point where you have approval to continue to work under this temp MOC. To address changes since the original temp was approved, select one of the options below.',
        Upload: 'Upload',
        Upload_CSV: 'Upload CSV',
        Upload_File_Attachment: 'Upload File Attachment',
        Upload_To_OpenText: 'Upload to OpenText required?',
        Update_Type: 'Update Type',
        Valid_Until_Date: 'Valid Until Date',
        ValidUntil_Date_Expired_Message: 'Valid Until Date has expired.',
        Valid_Until_Must_Come_After_Start: 'Valid Until Date must come after Start Date',
        Version: 'Version',
        Versions: 'Versions',
        Viewers: 'Viewers',
        Void: 'Void',
        Void_Reason: 'Void Reason',
        Validate_URL: 'Validate URL',
        Yes: 'Yes',
        Download_Archive: 'Download Archive',
        File_With_Same_Name: 'A file with that name has already been added',
        Search: 'Search',
        Total: 'Total',
        Score: 'Score',
        Previous: 'Previous',
        Next: 'Next',
        Across_All_Communities: 'across all communities',
        Across_This_Community: 'across this community',
        Page: 'Page',
        Errors: 'Errors',
        External_Approval_Success: 'Decision set successfully',
        External_Approval_Error: 'Decision could not be set',
        Prompt_External_Email: 'External user email',
        Invalid_Email_Error: 'Please provide a valid email address',
        Error_ExternalUserForbidden_MOC: 'You are not authorized to view this content. MOC Id: {{mocId}}',
        Owner_Approved_Start_Date: 'Owner approved start date',
        File_Extension_Blocked: 'This file type is not allowed',
        Approval_Response: 'Response',
        Click_To_See_History: 'Click to see history',
        Click_To_Hide_History: 'Click to hide story',
        Redirect_After_Save_MOC_Confirmation: 'Go back to dashboard?',
        Flags: 'Flags',
        Category_Owner_Unauthorized_Expired: 'Where I am Owner of an UNAUTHORIZED EXPIRED MOC',
        Category_Owner_Temporary_InProcess: 'Where I am Owner of a temporary MOC',
        Category_Owner_All_InProcess: 'Where I am Owner',
        Category_Coordinator_Unauthorized_Expired: 'Where I am the Coordinator of an UNAUTHORIZED EXPIRED MOC',
        Save_And_Continue_Process_Message:
          'This action may change tasks that are relevant to this MOC.  Do you wish to continue?',
        Error_SaveDraft: 'Error saving draft MOC',
        Error_SaveSubmit: 'Error submitting this MOC',
        Error_SaveSentBack: 'Error saving MOC',
        Error_SentBack: 'Error sending back this MOC',
        Error_Save: 'Error saving this MOC',
        Error_SendForDecision: 'Error setting MOC to Available for Decision',
        Error_SubmitPendingOwnerDecision: 'Error submitting MOC to Pending Owner Decision',
        Error_CloseVoid: 'Close Void Error',
        Error_CreateNewMoc: 'Error creating MOC',
        Error_SettingDecision: 'Error setting decision',
        Error_AddAdditionalApprovers: 'Error adding additional approvers',
        Error_AddAdditionalFyis: 'Error adding additional fyis',
        Error_OwnerReject: 'Error rejecting MOC',
        Try_Again_After_Save_MOC_Error: 'Please try again',
        Try_Again_And_Reload_After_Save_MOC_Error: 'Please refresh and try again',
        Error_ReturnToOriginal: 'Could not return to original',
        Error_MakeRevisions: 'Could not make revisions',
        Error_Close: 'Could not close MOC',
        Error_Extend: 'Could not extend MOC',
        Error_ClosedStranded: 'Close Strand Error',
        Hide_IT_Support_Details: 'Hide details for IT Support',
        Show_IT_Support_Details: 'Show details for IT Support',
        Copy_To_Clipboard: 'Copy to clipboard',
        Copy_To_Clipboard_Success: 'Copied to clipboard',
        Copy_To_Clipboard_Failed: 'Could not copy to clipboard',
        Save_Single_Task_Failed: 'Could not save task',
        Original_Pass: 'Original Pass',
        See_This_Version: 'Click to see details',
        Upload_File_Limit_Quantity: 'Please upload no more than 5 files at a time',
        File_Too_Large: 'File too large. 256MB max file size',
        Mandatory_Approver: 'Approval is mandatory',
        Someone_Else_Already_Change_This: 'Unable to complete this request.  This MOC has already been updated by another user',
        Error_Replace_User: 'An error has ocurred trying to replace this user',
        Details: 'Details',
        Category_OwnerDeferred: 'Where I am Owner but the start is deferred',
        Original_Decision: 'Original Decision',
        Unauthorized_Expired_Message_External_General:
          'You are past the point where there is approval to continue to work under this temporary MOC.',
        MOCs: 'MOCs',
        Community_Name: 'Community Name',
        Community_Abbreviation: 'Community Abbreviation',
        Rule_Valid_Link: 'Please provide a valid link',
        Documented_Information_Link: 'Documented Information Link',
        Add_Documented_Information: 'Add documented information',
        Supporting_Links_Warning:
          'Please make sure that you validate each link below before clicking on them.  If you suspect a link is malicious, please reach out to the <a href="mailto:{{processManagerEmail}}?subject=Malicious Link in {{mocid}}">Process Manager</a> for support.'
      }
    },
    cn: {
      translation: {
        Extended_Over_180_Message: 'Extended_Over_180_Message in Chinese'
      }
    }
  }
})

export { i18next };

export default function (app) {
  app.use(I18NextVue, { i18next })
  return app
}
